<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="modal-card">
    <section class="editor-preview">
      <div
        class="content-preview"
        :style="
          `width: ${page_format_mm[0] *
            responsiveZoom}mm; height: ${page_format_mm[1] * responsiveZoom}mm;`
        "
      >
        <article
          v-for="(page, index) in validateHTML"
          :key="index"
          :style="stylePage(index)"
          class="page-show"
          v-html="sanitizedHtml(page)"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { sanitizedHtml } from "@/utils/dataManipulation";

export default {
  name: "ViewEdowebModel",
  props: {
    html: {
      type: Array,
      default: () => [""]
    }
  },
  data() {
    return {
      sanitizedHtml,
      page_format_mm: [210, 297]
    };
  },
  computed: {
    responsiveZoom() {
      return 1.2;
    },
    validateHTML() {
      return this.html;
    }
  },
  methods: {
    stylePage(index) {
      return `transform: scale(${this.responsiveZoom}); top: ${
        index
          ? index * (this.page_format_mm[1] * this.responsiveZoom) +
            5.2 * (index + 1)
          : 5.2
      }mm;`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  width: calc(100% + 20px);
  min-height: calc(100% - 85px);
  max-height: 75vh;
  background-color: $background-color;
  overflow: auto;
}
.editor-preview {
  font-family: "Times New Roman", serif !important;
  font-size: 11pt !important;
  display: block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: default;
  .content-preview {
    position: relative;
    margin: 0;
    min-width: 100%;
    padding: 10px;
  }
}
.page-show {
  position: absolute;
  width: 210mm;
  padding: 10mm 15mm;
  min-height: 297mm;
  box-sizing: border-box;
  transform-origin: left top;
  background: var(--page-background, white);
  box-shadow: var(--page-box-shadow, 0 1px 3px 1px rgba(60, 64, 67, 0.15));
  border: var(--page-border);
  border-radius: var(--page-border-radius);
}
</style>
